import metadata from "./SubscribeFormComponent.metadata.json5";
import messages from "./SubscribeFormComponent.messages";
import styles from "./SubscribeFormComponent.module.scss";
import React, { useCallback, useContext, useState } from "react";
import { TranslatorContext } from "@jutro/locale";
import { ViewModelForm } from "gw-portals-viewmodel-react";
import timeZoneList from './timeZone.json';

function SubscribeFormComponent(props) {
    const translator = useContext(TranslatorContext);
    const [formData, updateFormData] = useState({});        
    
    const overrideProps = {
        subscribeStepIndicator: {
            content: translator(messages.subscribeStepIndicatorText)            
        },
        subscribeHeading: {
            content: translator(messages.subscribeHeadingText)
        },
        subscribeSuccessMessage: {
            message: translator(messages.subscribeSuccessMessageText),
            messageProps: translator(messages.subscribeSuccessMessageText)
        },
        enrollTextMessagingSubHeader: {
            content: translator(messages.enrollTextMessagingSubHeaderText)
        },
        enrollTextMessagingPara1: {
            content: translator(messages.enrollTextMessagingPara1Text)
        },
        enrollTextMessagingPara3: {
            content: translator(messages.enrollTextMessagingPara3Text)
        },
        enrollPaperlessSubHeader: {
            content: translator(messages.enrollPaperlessSubHeaderText)
        },
        enrollPaperlessPara1: {
            content: translator(messages.enrollPaperlessPara1Text)
        },
        typeaheadmultiselect: {
            availableValues: timeZoneList,
            value: '',
            onValueChange: '',
            className: true !== undefined ? 'timeZoneSelector timezoneBorder' : 'timeZoneSelector',
            showErrors: true === undefined
        },

    };
    
    const resolvers = {
        resolveClassNameMap: styles,
    };

    const writeValue = useCallback(
        (value, path) => updateFormData({
            ...formData,
            [path]: value
        }),
        [formData]
    );
    
    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={formData}
            overrideProps={overrideProps}
            onValueChange={writeValue}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );

}

export default SubscribeFormComponent;